<script>
import { Doughnut } from 'vue-chartjs'

export default {
  extends: Doughnut,
  props: ['data', 'options'],
  mounted () {
    this.render()
  },
  watch: {
    data (to, from) {
      this.render()
    }
  },
  methods: {
    render () {
      this.renderChart(this.data, this.options)
    }
  }
}
</script>
